
import { Vue, Component } from 'vue-property-decorator';
import { getAreas, saveinfo, getBaseInfo } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { Popup, Picker, Toast } from 'vant';
import Uploader from '../components/NewUploader.vue';
import qs from 'qs';

Vue.use(Popup)
  .use(Picker)
  .use(Toast);

@Component({
  components: {
    Uploader,
  },
})
export default class Active extends Vue {
  name = '';
  phone = '';
  addr = '';
  desc = '';
  videos: any = [];
  imgs: any = [];
  unionid: string | null = '';
  districts: any = [];
  selectedDistrict = '请选择区域';
  selectedDistrictId: any = [];
  showPicker = false;
  districts1: any = [];
  selectedDistrict1 = '请选择街道';
  selectedDistrictId1: any = [];
  showPicker1 = false;
  baseInfo: any = {};
  async mounted() {
    const ret111 = await getBaseInfo();
    this.baseInfo = ret111.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
    this.unionid = window.localStorage.getItem('unionid');
    const token = window.gettoken();
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (!token && window.udid) {
      this.AppLogin();
    }
    const ret = await getAreas('', '');
    for (const item of ret.data) {
      if (item.name === '重庆市') {
        const ret2 = await getAreas('district', '500100');
        ret2.data.forEach((item2: any) => {
          this.districts.push(item2.name);
          this.selectedDistrictId.push(item2.id);
        });
        break;
      }
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  async uploadImg() {
    this.imgs = (await (this.$refs
      .uploaderImg as Uploader).uploadToOss()) as string[];
  }
  submitinfo() {
    if (this.phone && !/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (this.imgs.length === 0) {
      Toast('请先上传至少一张图片！');
    } else {
      this.submitPerson();
    }
  }
  async submitPerson() {
    const token = window.gettoken();
    if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者上游APP打开');
      return;
    } else if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (!token && window.udid) {
      this.AppLogin();
    }
    // if (this.imgs.length > 0) {
    //   this.imgs = this.imgs.join('|').toString;
    // } else {
    //   this.imgs = '';
    // }
    // if (this.videos.length > 0) {
    //   this.videos = this.videos.join('|').toString;
    // } else {
    //   this.videos = '';
    // }
    const data = {
      unionid: this.unionid,
      name: this.name,
      phone: this.phone,
      county: this.selectedDistrict,
      street: this.selectedDistrict1,
      address: this.addr,
      cover: this.imgs.join('|'),
      desc: this.desc,
    };
    saveinfo(data).then((res: any) => {
      console.log('data:', res);
      if (res.code === 200) {
        Toast(res.msg);
        // this.addr = '';
        // this.desc = '';
        // this.imgs = [];
        // this.districts = [];
        // this.selectedDistrict = '请选择纠错区域';
        // this.selectedDistrictId = [];
        // this.showPicker = false;
        // this.districts1 = [];
        // this.selectedDistrict1 = '请选择纠错街道';
        // this.selectedDistrictId1 = [];
        // this.showPicker1 = false;
        window.location.reload();
      } else if (res.code === 202) {
        if (!this.unionid && isWeiXin()) {
          this.WechatLogin();
        } else if (!token && window.udid) {
          this.AppLogin();
        } else {
          Toast('请在微信或者上游APP打开');
          return false;
        }
      } else {
        Toast(res.msg);
        return false;
      }
    });
  }
  async onConfirm(d: string, i: number) {
    this.selectedDistrict = d;
    const ret = await getAreas('street', this.selectedDistrictId[i]);
    this.districts1.length = 0;
    this.selectedDistrictId1.length = 0;
    this.selectedDistrict1 = '请选择纠错街道';
    ret.data.forEach((item: any) => {
      this.districts1.push(item.name);
      this.selectedDistrictId1.push(item.id);
    });
    this.togglePicker();
  }
  onCancel() {
    this.togglePicker();
  }
  togglePicker() {
    this.showPicker = !this.showPicker;
  }
  onConfirm1(d: string, i: number) {
    this.selectedDistrict1 = d;
    this.togglePicker1();
  }
  onCancel1() {
    this.togglePicker1();
  }
  togglePicker1() {
    if (this.districts1.length > 0) {
      this.showPicker1 = !this.showPicker1;
    }
  }
}
